<script lang="ts" setup>
import { useAppStore } from '../stores/app';
import { getMenus } from '../utils/menu';

const { config } = useAppStore();
const menus = getMenus(config);
</script>

<template>
  <footer class="footer-outer">
    <div class="footer-area position-relative">
      <!-- <div class="watermark-bg h-full w-full">
        <img src="../assets/images/background-texts/footer-watermark.png" alt="" class="max-h-full w-full object-cover">
      </div> -->
      <div class="container position-relative">
        <div class="footer-wrapper">
          <div class="footer-watermark">
            <h1>Footer</h1>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-3 col-sm-5 order-1">
              <div class="footer-widget mt-0">
                <h5 class="footer-widget-title">
                  快速访问
                </h5>
                <div class="footer-links">
                  <ul class="link-list">
                    <li v-for="(menu, index) in menus" :key="index">
                      <template v-if="menu.isRouter">
                        <RouterLink :to="menu.path" class="footer-link">{{ menu.name }}</RouterLink>
                      </template>
                      <template v-else>
                        <a :href="menu.path" class="footer-link" target="_blank">{{ menu.name }}</a>
                      </template>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-6 order-lg-2 order-3">

              <div class="footer-about">
                <div class="footer-logo"><img src="../assets/images/logo-v2.png" alt="logo" class="h-56 w-171 object-contain"></div>
                <!-- <p>这是一段说明</p> -->
                <!-- eslint-disable-next-line @unocss/order -->
                <!-- <ul class="footer-social-icon d-flex">
                  <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                  <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                  <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                  <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                  <li><a href="#"><i class="fab fa-whatsapp"></i></a></li>
                </ul> -->
              </div>

            </div>
            <div class="col-lg-3 col-md-6 col-sm-7 order-lg-3 order-2">

              <div class="footer-widget">
                <h5 class="footer-widget-title">
                  联系我们
                </h5>
                <div class="footer-links">
                  <ul class="link-list">
                    <!-- <li class="contact-box">
                      <div class="contact-icon">
                        <i class="bi bi-telephone-plus"></i>
                      </div>
                      <div class="contact-links">
                        <a href="tel:+17632275032">+1 763-227-5032</a>
                        <a href="tel:+17632275032">+1 763-227-5032</a>
                      </div>
                    </li> -->
                    <li class="contact-box">
                      <div class="contact-icon">
                        <i class="bi bi-envelope-open"></i>
                      </div>
                      <div class="contact-links">
                        <a :href="`mailto:${config.extInfo.email}`">{{ config.extInfo.email }}</a>
                      </div>
                    </li>
                    <li class="contact-box">
                      <div class="contact-icon">
                        <i class="bi bi-geo-alt"></i>
                      </div>
                      <div class="contact-links">
                        <a href="javascript:;">{{ config.extInfo.address }}</a>
                      </div>
                    </li>

                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="footer-bottom footer-bottom-style-two">
          <div class="row align-items-center">
            <div class="col-lg-12">
              <div class="footer-copyright text-center">
                <p>
                  Copyright 2025 OPENATOM FOUNDATION. All rights reserved.
                </p>
                <p>
                  开放原子开源基金会版权所有 京ICP备2020036654号-1 京公网安备 11030102011597号
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
</style>
